import { useState, Fragment } from 'react';
import SvgIcon from '../../SvgIcon/SvgIcon';
import DesktopTableActions from './DesktopTableActions';

const DesktopTableBody = ({ data, columns, actions, noDataMessage }) => {
  const [expandedId, setExpandedId] = useState<number | null>(null);

  const toggleExpand = (id: number) => {
    setExpandedId((prev) => (prev === id ? null : id));
  };

  // ────────────────────────────────────────────
  // SIN DATOS
  // ────────────────────────────────────────────
  if (!data || data.length === 0) {
    return (
      <tbody>
        <tr>
          <td
            colSpan={columns.length + (actions ? 1 : 0)}
            className="
              px-4
              py-6
              text-center
              text-sm
              text-body
              dark:text-bodydark
            "
          >
            {noDataMessage}
          </td>
        </tr>
      </tbody>
    );
  }

  // ────────────────────────────────────────────
  // CON DATOS
  // ────────────────────────────────────────────
  return (
    <tbody>
      {data.map((row) => {
        const isExpanded = expandedId === row.id;

        return (
          <Fragment key={row.id}>
            {/* ──────────────────────────────────────────── */}
            {/* FILA PRINCIPAL */}
            {/* ──────────────────────────────────────────── */}

            <tr
              className="
                border-b
                border-stroke

                transition-colors
                duration-200

                hover:bg-primary
                hover:bg-opacity-5

                dark:border-strokedark
                dark:hover:bg-meta-4
              "
            >
              {/* Columnas */}
              {columns.map((col) => (
                <td
                  key={col.accessor}
                  className="
                    px-4
                    py-2

                    text-sm
                    text-black

                    dark:text-white
                  "
                >
                  {col.render ? col.render(row) : row[col.accessor] ?? '—'}
                </td>
              ))}

              {/* Acciones */}
              {actions && (
                <td className="px-4 py-2">
                  <div className="flex justify-center">
                    <button
                      type="button"
                      onClick={() => toggleExpand(row.id)}
                      className="
                        inline-flex
                        h-[42px]
                        items-center
                        justify-center

                        gap-2

                        rounded-xl

                        bg-primary

                        px-4

                        text-xs
                        font-medium
                        text-white

                        shadow-1

                        transition-all
                        duration-200

                        hover:scale-[1.01]
                        hover:opacity-90

                        active:scale-[0.99]
                      "
                    >
                      <span>Acciones</span>

                      <span
                        className={`
                          flex
                          items-center
                          justify-center

                          transition-transform
                          duration-200

                          ${isExpanded ? 'rotate-180' : ''}
                        `}
                      >
                        <SvgIcon name="chevron-down" width={14} height={14} />
                      </span>
                    </button>
                  </div>
                </td>
              )}
            </tr>

            {/* ──────────────────────────────────────────── */}
            {/* PANEL EXPANDIDO */}
            {/* ──────────────────────────────────────────── */}

            {isExpanded && (
              <tr
                className="
                  bg-whiten

                  transition-colors
                  duration-200

                  dark:bg-boxdark
                "
              >
                <td
                  colSpan={columns.length + (actions ? 1 : 0)}
                  className="px-4 py-4"
                >
                  <DesktopTableActions row={row} actions={actions} />
                </td>
              </tr>
            )}
          </Fragment>
        );
      })}
    </tbody>
  );
};

export default DesktopTableBody;
